import {
    ADD_FAVOURITE_VALUE_STREAM_SUCCESS,
    FETCH_ALL_VALUE_STREAM_SUCCESS,
    FETCH_VALUE_STREAM_SUCCESS,
    FILTER_VALUE_STREAM,
    GET_ALL_VALUE_STREAM,
    GET_UNSELECTED_ALL_VALUE_STREAM,
    HANDLE_VALUE_STREAM_REQUEST_CLOSE,
    HIDE_VALUE_STREAM_LOADER,
    SHOW_VALUE_STREAM_LOADER,
    ON_ADD_VALUE_STREAM,
    ON_EDIT_VALUE_STREAM,
    ON_ALL_VALUE_STREAM_SELECT,
    ON_VALUE_STREAM_CLOSE,
    ON_VALUE_STREAM_SELECT,
    ON_DELETE_VALUE_STREAM_SUCCESS,
    ON_FILTER_SELECTED_VALUE_STREAM,
    ON_FILTER_VALUE_STREAM_OPTION_SELECT,
    ON_SAVE_VALUE_STREAM_SUCCESS,
    ON_TOGGLE_VALUE_STREAM_DRAWER,
    SHOW_VALUE_STREAM_MESSAGE,
    UPDATE_SEARCH_VALUE_STREAM,
    SET_VALUE_STREAM,
    CLEAR_SESSION,
    ON_FETCH_SELECT_TEAM_DATA_SUCCESS,
    CLEAR_SELECTED_OBJECTS,
} from 'constants/ActionTypes';
import { addOrUpdateEntry } from 'services/arrayService';

export const ALL_FILTER = 'All value streams';
export const STARRED_FILTER = 'Starred value streams';
export const SUCCESSFUL_UPDATE = 'Value stream Updated Successfully';
export const SUCCESSFUL_FILTER = 'Value stream Filtered Successfully';
export const SUCCESSFUL_DELETE = 'Value stream Deleted Successfully';
export const REMOVED_AS_STAR = 'Value stream removed as star';
export const MARKED_AS_STAR = 'Value stream marked as star';

export const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No value streams found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: ALL_FILTER,
    allValueStream: [],
    valueStreamList: [],
    selectedValueStream: null,
    selectedValueStreams: 0,
    addValueStreamState: false,
    editValueStreamState: false,
    searchValueStream: '',
    teamSelectionList: [],
    selectedTeams: 0,
    valueStream: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case CLEAR_SELECTED_OBJECTS: {
            return {
                ...state,
                selectedValueStream: null,
            };
        }
        case ON_FETCH_SELECT_TEAM_DATA_SUCCESS: {
            return {
                ...state,
                teamSelectionList: action?.payload,
                loader: false,
            };
        }
        case SET_VALUE_STREAM: {
            const valueStreams = state.allValueStream.filter((entry) => entry?.id === action?.payload);
            return {
                ...state,
                loader: false,
                selectedValueStream: valueStreams?.length > 0 ? valueStreams[0] : [],
            };
        }
        case ADD_FAVOURITE_VALUE_STREAM_SUCCESS: {
            const allUpdated = state.allValueStream.map((entry) => entry?.id === action?.payload?.id ? {
                ...entry,
                starred: !action?.payload?.starred
            } : entry);
            let listUpdated = {};
            switch (state.filterOption) {
                case ALL_FILTER: {
                    listUpdated = allUpdated;
                    break;
                }
                case STARRED_FILTER: {
                    listUpdated = allUpdated.filter((entry) => entry.starred);
                    break;
                }
            }
            return {
                ...state,
                alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
                showMessage: true,
                valueStreamList: listUpdated,
                allValueStream: allUpdated,
            };
        }
        case FETCH_VALUE_STREAM_SUCCESS: {
            return {
                ...state,
                loader: false,
                selectedValueStream: action.payload,
                addValueStreamState: false,
                editValueStreamState: false,
            };
        }
        case FETCH_ALL_VALUE_STREAM_SUCCESS: {
            return {
                ...state,
                loader: false,
                allValueStream: action.payload,
                valueStreamList: action.payload,
                selectedSectionId: 1,
                searchEmp: '',
                filterOption: ALL_FILTER,
                addValueStreamState: false,
                editValueStreamState: false,
            };
        }
        case SHOW_VALUE_STREAM_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case ON_VALUE_STREAM_SELECT: {
            action.payload.selected = !action.payload.selected;
            let selectedTeams = 0;
            const teamSelectionList = state.teamSelectionList.map(team => {
                if (team.selected) {
                    selectedTeams++;
                }
                if (team.id === action.payload.id) {
                    if (team.selected) {
                        selectedTeams++;
                    }
                    return action.payload;
                } else {
                    return team;
                }
            }
            );
            return {
                ...state, INIT_STATE,
                selectedTeams: selectedTeams,
                teamSelectionList: teamSelectionList
            };
        }
        case ON_ADD_VALUE_STREAM: {
            return {
                ...state,
                addValueStreamState: true,
                editValueStreamState: false,
            };
        }
        case ON_EDIT_VALUE_STREAM: {
            return {
                ...state,
                selectedValueStream: action.payload,
                editValueStreamState: true,
                addValueStreamState: false,
            };
        }
        case ON_VALUE_STREAM_CLOSE: {
            return {
                ...state,
                addValueStreamState: false,
                editValueStreamState: false,
            };
        }
        case ON_FILTER_VALUE_STREAM_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let valueStreamList = [];
            switch (action.payload.name) {
                case ALL_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    valueStreamList = state.allValueStream;
                    break;
                }
                case STARRED_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    valueStreamList = state.allValueStream.filter((valueStream) => valueStream.starred);
                    break;
                }
            }
            return {
                ...state, selectedSectionId, filterOption, valueStreamList, drawerState: false
            };
        }
        case ON_SAVE_VALUE_STREAM_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_UPDATE,
                showMessage: true,
                valueStreamList: addOrUpdateEntry(state.valueStreamList, action.payload),
                allValueStream: addOrUpdateEntry(state.allValueStream, action.payload),
                selectedValueStream: action.payload,
                loader: false,
            };
        }
        // called after a delete from the db operation to keep the current state up to date
        case ON_DELETE_VALUE_STREAM_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_DELETE,
                showMessage: true,
                allValueStream: state.allValueStream.filter((valueStream) => valueStream.id !== action.payload),
                valueStreamList: state.allValueStream.filter((valueStream) => valueStream.id !== action.payload),
                selectedValueStream: null,
            };
        }
        case ON_FILTER_SELECTED_VALUE_STREAM: {
            const valueStreams = state.allValueStream.filter((valueStream) => !valueStream.selected);
            return {
                ...state,
                alertMessage: SUCCESSFUL_FILTER,
                showMessage: true,
                valueStreamList: valueStreams,
                selectedValueStreams: 0
            };
        }
        case FILTER_VALUE_STREAM: {
            const { filterOption } = state;
            let valueStreamList = [];
            if (action.payload === '') {
                valueStreamList = state.allValueStream;
            } else {
                const filterValueStream = state.allValueStream.filter((valueStream) =>
                    valueStream.name.toLowerCase().indexOf(action.payload.toLowerCase()) > - 1);
                if (filterOption === ALL_FILTER) {
                    valueStreamList = filterValueStream;
                } else if (filterOption === STARRED_FILTER) {
                    valueStreamList = filterValueStream.filter((valueStream) => valueStream.starred);
                }
            }
            return { ...state, valueStreamList: valueStreamList };
        }
        case GET_ALL_VALUE_STREAM: {
            let valueStreamList = state.allValueStream.map((valueStream) => valueStream ? {
                ...valueStream,
                selected: true
            } : valueStream);
            return {
                ...state,
                selectedValueStreams: valueStreamList.length,
                allValueStream: valueStreamList,
                valueStreamList: valueStreamList
            };
        }
        case GET_UNSELECTED_ALL_VALUE_STREAM: {
            let valueStreamList = state.allValueStream.map((valueStream) => valueStream ? {
                ...valueStream,
                selected: false
            } : valueStream);
            return {
                ...state,
                selectedValueStreams: 0,
                allValueStream: valueStreamList,
                valueStreamList: valueStreamList
            };
        }
        case ON_ALL_VALUE_STREAM_SELECT: {
            const selectAll = state.selectedValueStreams < state.valueStreamList.length;
            let selectedValueStreams = 0;
            let valueStreamList = [];
            if (selectAll) {
                valueStreamList = state.allValueStream.map((valueStream) => valueStream ? {
                    ...valueStream,
                    selected: true
                } : valueStream);
                selectedValueStreams = valueStreamList.length;
            } else {
                valueStreamList = state.allValueStream.map((valueStream) => valueStream ? {
                    ...valueStream,
                    selected: true
                } : valueStream);
                selectedValueStreams = 0;
            }
            return {
                ...state,
                selectedValueStreams: selectedValueStreams,
                allValueStream: valueStreamList,
                valueStreamList: valueStreamList
            };
        }
        case UPDATE_SEARCH_VALUE_STREAM: {
            return { ...state, searchValueStream: action.payload };
        }
        case HANDLE_VALUE_STREAM_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_VALUE_STREAM_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_VALUE_STREAM_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_VALUE_STREAM_LOADER: {
            return { ...state, loader: false };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/valueStream.js